import { render } from "./CropTreatment.vue?vue&type=template&id=aed8eb58&scoped=true&ts=true"
import script from "./CropTreatment.vue?vue&type=script&lang=ts"
export * from "./CropTreatment.vue?vue&type=script&lang=ts"

import "./CropTreatment.vue?vue&type=style&index=0&id=aed8eb58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aed8eb58"]])

export default __exports__